import type { Permission } from '@core/constants/permissions';

const DEPENDENCIES: Record<string, Permission[]> = {
  manage_customers: ['list_customer', 'create_customer', 'update_customer', 'change_status_customer'],
  manage_secondary_customer_debt: ['list_customer'],
  create_remittance: ['view_remittance', 'list_remittance'],
  update_remittance: ['view_remittance', 'list_remittance'],
  change_state_remittance: ['view_remittance', 'list_remittance'],
  remittance_introduction_letter: ['view_remittance', 'list_remittance'],
  delete_remittance: ['view_remittance', 'list_remittance'],

  create_insurance_contract: ['list_insurance_contract'],

  create_bill_loading: [
    'view_bill_loading',
    'list_bill_loading',
    'view_remittance',
    'list_remittance',
  ],
  update_bill_loading: ['view_bill_loading', 'list_bill_loading'],
  cancel_bill_loading: ['view_bill_loading', 'list_bill_loading'],
  convert_bill_loading_to_canceled: ['view_bill_loading', 'list_bill_loading'],
  delete_bill_loading: ['view_bill_loading', 'list_bill_loading'],
  roadway_register_bill_loading: ['view_bill_loading', 'list_bill_loading'],
  register_manual_bill_loading_tracking_code: ['view_bill_loading', 'list_bill_loading'],
  waybill_change_status: ['view_bill_loading', 'list_bill_loading'],
  reference_bill_loading: ['view_bill_loading', 'list_bill_loading'],
};

export const expandPermissions = (permissions: readonly Permission[]): Permission[] => {
  const expanded = new Set<Permission>(permissions);
  let changed = true;

  while (changed) {
    changed = false;
    [...expanded].forEach((permission) => {
      (DEPENDENCIES[permission] ?? []).forEach((dependency) => {
        if (!expanded.has(dependency)) {
          expanded.add(dependency);
          changed = true;
        }
      });
    });
  }

  return [...expanded];
};
